module.exports = __webpack_public_path__ + "static/media/us.ae656592.svg";